export const EDUCATION_ROUTE_SECTION_PARAM = 'section';

export const EDUCATION_TEST_CONFIG = {
  routeSectionParam: EDUCATION_ROUTE_SECTION_PARAM,
  defaultRouteId: 'knowledge-library',
  defaultFilter: 'all',
  defaultSort: 'name',
  filterBadgeCount: 10,
};

export const EDUCATION_TEST_ROUTES = [
  {
    id: 'knowledge-library',
    name: 'education',
    to: { name: 'education' },
    icon: 'knowledge-library',
    labelKey: 'education.knowledgeLibrary',
  },
  {
    id: 'question-bank',
    name: 'education-question-bank',
    to: { name: 'education', query: { [EDUCATION_ROUTE_SECTION_PARAM]: 'question-bank' } },
    icon: 'question-bank',
    labelKey: 'education.questionBank',
  },
  {
    id: 'achievements',
    name: 'education-achievements',
    to: { name: 'education', query: { [EDUCATION_ROUTE_SECTION_PARAM]: 'achievements' } },
    icon: 'achievements',
    labelKey: 'education.achievements',
  },
  {
    id: 'report',
    name: 'education-report',
    to: { name: 'education', query: { [EDUCATION_ROUTE_SECTION_PARAM]: 'report' } },
    icon: 'report',
    labelKey: 'education.report',
  },
];

export const EDUCATION_TEST_FILTERS = [
  { value: 'all', labelKey: 'education.filtersAll' },
  { value: 'course', labelKey: 'education.filtersCourse' },
  { value: 'document', labelKey: 'education.filtersDocument' },
  { value: 'active', labelKey: 'education.filtersPublished' },
  { value: 'draft', labelKey: 'education.filtersDraft' },
];

export const EDUCATION_TEST_SORT_OPTIONS = [
  { value: 'name', labelKey: 'education.sortByName' },
  { value: 'views', labelKey: 'education.sortByViews' },
  { value: 'rating', labelKey: 'education.sortByRating' },
];

export const EDUCATION_TEST_COLUMNS = [
  { key: 'name', labelKey: 'education.columnsName' },
  { key: 'category', labelKey: 'education.columnsCategory' },
  { key: 'status', labelKey: 'education.columnsStatus' },
  { key: 'views', labelKey: 'education.columnsViews' },
  { key: 'rating', labelKey: 'education.columnsRating' },
];
